





















































import { useFilters } from '@/app/composable';
import { useAsset } from '@/modules/asset/composable/asset';
import { Asset } from '@/modules/asset/types';
import { CalendarIcon, OfficeBuildingIcon, ShoppingCartIcon } from '@vue-hero-icons/solid';
import { PropType, defineComponent, computed } from '@vue/composition-api';
import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import { useCart } from '../../composable';

dayjs.extend(minMax);

export default defineComponent({
    name: 'AssetCard',
    components: {
        ShoppingCartIcon,
        CalendarIcon,
        OfficeBuildingIcon,
    },
    props: {
        asset: {
            type: Object as PropType<Asset>,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const { formatDateTime } = useFilters();

        const { cartAssetIds } = useCart();
        const { assetTypeClass, assetTypeName } = useAsset();

        const providedBy = computed(() => {
            return props.asset.organisation
                ? props.asset.organisation.businessName
                : `${props.asset.createdBy.firstName} ${props.asset.createdBy.lastName}`;
        });

        return {
            dayjs,
            assetTypeClass,
            assetTypeName,
            formatDateTime,
            cartAssetIds,
            providedBy,
        };
    },
});
